var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailableBalanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H40C41.933 0.5 43.5 2.067 43.5 4V40C43.5 41.933 41.933 43.5 40 43.5H4C2.067 43.5 0.5 41.933 0.5 40V4Z",
    fill: "#DDFBE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H40C41.933 0.5 43.5 2.067 43.5 4V40C43.5 41.933 41.933 43.5 40 43.5H4C2.067 43.5 0.5 41.933 0.5 40V4Z",
    stroke: "#8AEBA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13.5H17C14 13.5 12 15 12 18.5V25.5C12 29 14 30.5 17 30.5H27C30 30.5 32 29 32 25.5V18.5C32 15 30 13.5 27 13.5ZM16.25 24.5C16.25 24.91 15.91 25.25 15.5 25.25C15.09 25.25 14.75 24.91 14.75 24.5V19.5C14.75 19.09 15.09 18.75 15.5 18.75C15.91 18.75 16.25 19.09 16.25 19.5V24.5ZM22 25C20.34 25 19 23.66 19 22C19 20.34 20.34 19 22 19C23.66 19 25 20.34 25 22C25 23.66 23.66 25 22 25ZM29.25 24.5C29.25 24.91 28.91 25.25 28.5 25.25C28.09 25.25 27.75 24.91 27.75 24.5V19.5C27.75 19.09 28.09 18.75 28.5 18.75C28.91 18.75 29.25 19.09 29.25 19.5V24.5Z",
    fill: "#2BB954"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableBalanceIcon);
export default __webpack_public_path__ + "static/media/available_balance_icon.77c3cb5b2b8a0d0b96bcacf613effa6f.svg";
export { ForwardRef as ReactComponent };